import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getPageDescription } from "../data/pagedescription";

export default function RouteMetadata() {
    const { pathname } = useLocation();

    useEffect(() => {
        let description = document.head.querySelector('meta[name="description"]');
        if (!description) {
            description = document.createElement("meta");
            description.setAttribute("name", "description");
            document.head.appendChild(description);
        }
        description.setAttribute("content", getPageDescription(pathname));
    }, [pathname]);

    return null;
}
